module.exports = __webpack_public_path__ + "static/media/interior_340.a307ca98.png";